// const formValidation = require('../components/formValidation');

module.exports = {
  addressPredictionByZipCode() {
    function setStateValue(select, name) {
      const stateSelect = select;
      const options = $('option', stateSelect);
      for (let i = 0; i < options.length; i++) {
        const option = options[i];
        if (option.text.localeCompare(name) === 0) {
          stateSelect[0].selectedIndex = option.index;
          stateSelect.change();
          // Dispatch event to fix Jquery bug with Vue
          stateSelect[0].dispatchEvent(new Event('change'));
          break;
        }
      }
    }

    const zipCodeInput = document.querySelector('input#zipCode');
    if (!zipCodeInput) return;

    function processZipCode() {
      const input = $(zipCodeInput);
      const form = input.closest('form');
      const stateSelect = $('select#state', form);
      if (stateSelect.length <= 0) return;
      const cityInput = $('input#city', form);
      if (cityInput.length <= 0) return;
      if (stateSelect[0].selectedIndex === 0 || cityInput.val() === '') {
        const zipCode = input.val();
        const [lang, country] = $('#byl-header').data('locale').split('_');
        const apiKey = $('#maps-api-key').val();
        const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&components=country:${country}&language=${lang}&key=${apiKey}`;
        $.ajax({
          apiUrl,
          type: 'get',
          success(data) {
            if (data.status === 'OK') {
              const addressComponents = data.results[0].address_components;
              for (let i = 0; i < addressComponents.length; i++) {
                const component = addressComponents[i];
                if (
                  component.types[0] === 'locality' &&
                  cityInput.val() === ''
                ) {
                  cityInput.val(component.long_name);
                  // Dispatch event to fix Jquery bug with Vue
                  cityInput[0].dispatchEvent(new Event('input'));
                }
                if (
                  stateSelect[0].selectedIndex === 0 &&
                  (component.types[0] === 'administrative_area_level_1' ||
                    component.types[0] === 'administrative_area_level_2')
                ) {
                  setStateValue(stateSelect, component.long_name);
                }
                if (
                  cityInput.val() !== '' &&
                  stateSelect[0].selectedIndex !== 0
                ) {
                  break;
                }
              }
            }
          },
        });
      }
    }

    zipCodeInput.addEventListener('focusout', processZipCode);
  },
};
